// src/components/store/sections/faqs/FaqV77TicketfaqCrimsonRose.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV77TicketfaqCrimsonRose(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={77}
      archKey="ticket_faq"
      archLabel="Perforated Ticket Q&A"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
